import React from 'react';
import { Button, Col, Input, Label, Row } from 'reactstrap';

import styles from './Time.module.scss';

import { ITimeFilter } from '../../../../interfaces/filters.interface';

interface Props {
  isSingle: boolean;
  timeList: ITimeFilter[];
  onHideSidebar: () => void;
  onSave: (timeList) => void;
}

interface State {
  timeList: ITimeFilter[];
}

export default class TimeSidebar extends React.Component<Props, State> {
  constructor(props) {
    super(props);

    this.state = {
      timeList: this.props.timeList
    };
  }

  hideRightSidebar(): void {
    this.props.onHideSidebar();
  }

  updateTime(timeIndex: number): void {
    this.state.timeList[timeIndex].selected = !this.state.timeList[timeIndex].selected;
    this.state.timeList[timeIndex].quarters.map((quarter) => {
      quarter.selected = this.state.timeList[timeIndex].selected;
      return quarter;
    });

    this.setState({timeList: this.state.timeList});
  }

  updateQuarter(timeIndex: number, quarterIndex: number): void {
    if (this.props.isSingle) {
      this.state.timeList.forEach((year, yIdx: number) => {
        year.quarters.forEach((quarter, qIdx: number) => {
          if (yIdx === timeIndex && qIdx === quarterIndex) {
            quarter.selected = !quarter.selected;
          } else {
            quarter.selected = false;
          }
        });
      })
    } else {
      this.state.timeList[timeIndex].quarters[quarterIndex].selected =
        !this.state.timeList[timeIndex].quarters[quarterIndex].selected;
      this.state.timeList[timeIndex].selected =
        this.state.timeList[timeIndex].quarters.reduce((acc, value) => {
          acc = acc && value.selected;
          return acc;
        }, true);
    }

    this.setState({timeList: this.state.timeList});
  }

  onSave(): void {
    this.props.onSave(this.state.timeList);
  }

  render(): React.ReactNode {
    return (
      <React.Fragment>
        <div className="right-bar">

          <div className="h-100 position-relative">
            <div className="rightbar-title px-3 py-4">
              <h5 className="m-0">Time</h5>
              <div
                className="right-bar-toggle"
                onClick={() => this.hideRightSidebar()}
              >
                <i className="mdi mdi-close"/>
              </div>
            </div>

            <div className="px-3 py-4">

              {
                this.state.timeList.map((time, timeIdx: number) => (
                  <div key={timeIdx}>
                    <Row className={styles['time-container']}>
                      <Col md={3} className={styles['time-row']}>
                        <div className="form-check mb-0">
                          {
                            !this.props.isSingle &&
                            <Input
                                id={time.name}
                                type="checkbox"
                                onChange={() => this.updateTime(timeIdx)}
                                checked={time.selected}
                                className="form-check-input me-2"
                            />
                          }
                          <Label
                            htmlFor={time.name}
                            className="form-check-label"
                          >
                            {time.name}
                          </Label>
                        </div>
                      </Col>

                      <Col md={9}>

                        <Row>
                          {
                            time.quarters.map((quarter, quarterIdx: number) => (
                              <Col md={3} key={quarterIdx}>
                                <div
                                  className={`${styles['quarter-container']} ${quarter.selected && styles.active}`}
                                  onClick={() => this.updateQuarter(timeIdx, quarterIdx)}
                                >
                                  <p className={styles['text-label']}>{quarter.name}</p>
                                </div>
                              </Col>
                            ))
                          }
                        </Row>

                      </Col>
                    </Row>

                    {
                      this.state.timeList.length - 1 !== timeIdx &&
                      <hr className="my-0"/>
                    }
                  </div>
                ))
              }

              <div className={`${styles['footer-button']} px-3`}>
                <Row>
                  <Col md={6}>
                    <Button
                      color={'primary w-100'}
                      outline
                      className={'waves-effect waves-light'}
                      onClick={() => this.hideRightSidebar()}
                    >
                      Cancel
                    </Button>
                  </Col>

                  <Col md={6}>
                    <Button
                      color={'primary w-100'}
                      className={'waves-effect waves-light'}
                      onClick={() => this.onSave()}
                    >
                      Select
                    </Button>
                  </Col>
                </Row>
              </div>

            </div>
          </div>
        </div>

        <div className="rightbar-overlay"/>
      </React.Fragment>
    );
  }
}
